
import React, { useState } from 'react';
import { Button, Input, message, Steps, theme } from 'antd';

import '../../build.css'
import Buildtable from '../Buildtable';



 const Sop1=() =>{
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [  
    
    {
      title: 'Introduction',
      content: <>
      <div   style={{marginTop:'2rem',}}>
      <Buildtable />
      <h6 id="profile" style={{color:'blue'}}>STATEMENT OF PURPOSE</h6>
      <p style={{ marginTop: "1rem" }}>
      In the scenario where you are staying within the same academic stream and have relevant work experience, the "Career Goals" section can have a significant impact on your Statement of Purpose (SOP). This section is an opportunity to showcase how your professional background has shaped your aspirations and how the master's program aligns with your career trajectory.
                </p>


           
                 <p> <strong>Career Goals section will be the Key Emphasis Section </strong> </p>
                 <p></p>
                <br></br>
                <h6>Introduction: </h6>
                <p>In the introduction, you want to grab the reader's attention by clearly stating the academic field you are passionate about. Rather than beginning with personal details, dive into the subject matter. Explain what aspects of this field interest you and why. This could include specific experiences, classes, or personal moments that sparked your interest. Convey your enthusiasm for the subject and provide a brief glimpse into what you hope to achieve within this domain.</p>
                <p>
                  <strong >Mistakes that need to be taken care of: </strong> 
                  <br></br>
                  <strong>Avoid Ambiguity:</strong> Clearly articulate why this field captures your interest. Vague statements may leave the reader unsure about your genuine passion.
                 <p> <strong>Steer Clear of Clichés:</strong>  Be original in expressing your interest. Avoid clichés that might make your introduction sound generic.</p>
                </p>
                <br></br>
                


                <hr></hr>
              
       
        </div></>,
    },
    {
      title: 'background',
      content: <>
  <div className='martop'  > <p>
                  <strong>Background:-</strong> 
                  This section is an opportunity to showcase your academic and, if applicable, professional journey. Detail your academic achievements, focusing on relevant courses or projects that have prepared you for the desired program. If you have work experience, highlight how it has contributed to your skills and knowledge. In the case of extracurricular activities, emphasize those that demonstrate skills applicable to the academic and professional world.
                
                </p>
               <p><strong>Mistakes that need to be taken care of: </strong>
                </p>
              <p><strong>Irrelevant Details:</strong></p>
                <p>While providing your background, stay focused on elements that directly contribute to your suitability for the program. Avoid unnecessary details.</p>
                <h6> <strong>Overemphasis on Grades:</strong></h6>
                <p> While academic achievements are important, balance the discussion with other aspects of your background to present a holistic picture.</p>
               

     
                
                {/* <hr></hr> */}

                <hr></hr></div> </>,
    },
    {
        title: 'Course',
        content: <>  <div class=" martop" >
  
      
<p><strong>Why this Course: </strong></p>
Here, elaborate on why you are specifically interested in the course you are applying for. Discuss specific aspects of the curriculum that align with your academic and career goals. Go beyond a surface-level description; delve into the unique features, specializations, or projects that attracted you to this course. 
        <p>
        <p>  <strong>Mistakes that need to be taken care of: </strong>      </p>  

        <p><strong>Generic Statements: </strong></p>
        Avoid broad statements about the course. Dive into the specifics of the curriculum, mentioning particular courses or projects that resonate with your aspirations.
        </p>
<p><strong>Neglecting Skills Enhancement: </strong>
  Clearly explain how the course will enhance your skills and contribute to your professional development.
</p>
     
        <hr></hr>
        </div>
        </>,
      },
      {
        title: 'Goals',
        content: <>
        <div className='martop'></div>
          <p >
                    <strong>Career Goals - Key Emphasis Section: </strong>
                  </p>
                  <p><strong>What to Include: </strong></p>
                  <p><strong>1 .Professional Experience Integration: </strong></p>
                  <p>
                  Explicitly connect your past professional experience to your future career goals. Showcase how the skills and knowledge gained during your job contribute to your readiness for the master's program and, subsequently, your career objectives.
                  </p>
                <p><strong>2. Career Progression Narrative: </strong></p>
                <p>Craft a narrative that explains the progression of your career and how the master's program is the logical next step. Discuss specific projects, responsibilities, or achievements from your work experience that directly relate to the skills you aim to enhance through the master's program.</p>
                <p><strong>3. Skills Enhancement and Specialization: </strong>Outline the specific skills you aim to enhance through the master's program and how these skills will make you more adept in your current or desired role. Discuss any specializations within the program that directly align with your career goals.</p>

                <p><strong>4. Industry Trends and Innovation: </strong> Demonstrate your awareness of current trends and innovations in your industry. Discuss how the master's program will equip you with the knowledge needed to navigate these trends and contribute meaningfully to the field.</p>
                <p><strong>5. Long-Term Vision: </strong> Provide insight into your long-term vision for your career. Discuss how you see yourself contributing to the industry and any leadership roles you aspire to attain. Showcase ambition while maintaining a sense of realism.</p>     

                <p   ><strong>How to Pen It: </strong>Begin by providing a brief overview of your professional journey, highlighting key experiences and achievements. Emphasize how these experiences have influenced your decision to pursue further education.</p>
       
       <p>Clearly state your immediate goals after completing the master's program and how these align with your current or desired role in the industry. Be specific about the skills you aim to acquire and how they will contribute to your effectiveness in the field.</p>
       <p>Discuss any challenges or opportunities in your industry that you hope to address through your education and future contributions. This shows a proactive and forward-thinking approach.</p>
       <p>Connect the master's program directly to your career goals. Discuss specific aspects of the curriculum, faculty expertise, or resources that make it the ideal choice for advancing your professional journey.</p>
       <p>Conclude by reaffirming your commitment to making a meaningful impact in your industry and how the master's program is integral to achieving these goals.</p>    
        </>,
      },
      {
        title: 'Second',
        content: <>
      
       <p    style={{marginTop: '10px',}}><strong>Example:</strong></p>
       <p>My journey in [industry] has been characterized by [specific achievements or challenges], providing me with a nuanced understanding of the intricacies of [industry]. This experience has crystallized my desire to elevate my contributions in [specific area], and I am confident that pursuing a master's in [Course Name] at [University] is the pivotal next step. Through my work at [Company], I have honed skills in [mention skills], and I am eager to augment this foundation through the specialized coursework offered by [University]. The innovative approach of [Course Name], particularly the focus on [specific aspect], aligns seamlessly with my aspirations to [career goal]. I am excited about the prospect of contributing to [industry trends or challenges] and believe that [University] is the ideal environment to nurture these ambitions. This master's program is not just a qualification; it is the catalyst for achieving my long-term vision of [long-term career goal].</p>
       <p><strong>Why this University: </strong></p>
       <p>This section is your chance to show that you've done your homework on the university. Highlight specific features, resources, or faculty members that attract you. Explain how these elements align with your academic and career objectives. Convey a genuine interest in what the university offers beyond just a prestigious name.</p>
       <p><strong>Mistakes that need to be taken care of:</strong></p>
       <p> <strong>Generic Praise:</strong> Avoid using generic statements about the university's reputation. Instead, focus on unique features that resonate with your goals.</p>
       <p> <strong>Lack of Personalization: </strong> Ensure your reasons for choosing the university go beyond general information available on their website. Personalize your response to demonstrate a deep understanding.</p>

       <br></br>
       <hr></hr>
       <p><strong>Conclusion: </strong> Summarize the key points discussed in your Statement of Purpose. Reiterate your passion for the chosen field and emphasize how the course at the university is a crucial step toward achieving your goals. End on a strong note, leaving a lasting impression.</p>
       <p><strong>Mistakes that need to be taken care of:</strong></p>
       <p><strong>Introducing New Information:</strong> The conclusion is not the place for new information. Stick to summarizing what you've already discussed</p>
       <p><strong>Lack of Confidence: </strong>  Convey confidence in your goals and how the chosen course at the university is integral to your success.</p>
        </>,
      },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 24,
        }}
      >
         {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}{current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
       
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success(`Processing complete! Input: ${inputValue}`)}>
            Done
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Sop1;
